"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyAppApi = exports.setAppApiOptions = void 0;

var _react = require("@reduxjs/toolkit/dist/query/react");

var _reduxPersist = require("redux-persist");

var _path = require("../constants/path.constants");

var _utils = require("../utils");

var _createFetchBaseQuery = (0, _utils.createFetchBaseQueryWithToken)(),
    setAppApiOptions = _createFetchBaseQuery.setApiOptions,
    baseQuery = _createFetchBaseQuery.baseQuery;

exports.setAppApiOptions = setAppApiOptions;
var coreApiReducerPath = "".concat(_path.API_BASE_REDUCER_PATH, "coreApi");
var emptyAppApi = (0, _react.createApi)({
  reducerPath: coreApiReducerPath,
  baseQuery: (0, _utils.fetchBaseQueryWithReAuthMutex)(baseQuery()),
  tagTypes: [],
  extractRehydrationInfo: function extractRehydrationInfo(action, _ref) {
    var reducerPath = _ref.reducerPath;

    if (action.type === _reduxPersist.REHYDRATE) {
      var _action$payload;

      return (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload[reducerPath];
    }

    return undefined;
  },
  endpoints: function endpoints() {
    return {};
  }
});
exports.emptyAppApi = emptyAppApi;